import { render, staticRenderFns } from "./subMenuSecond.vue?vue&type=template&id=edb7d93e"
import script from "./subMenuSecond.vue?vue&type=script&lang=js"
export * from "./subMenuSecond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports